'use client';
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  styled,
  type ToggleButtonGroupProps,
} from '@mui/material';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { type MouseEvent, type ReactNode, useCallback } from 'react';

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    borderRadius: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
  },
  [`& .${toggleButtonGroupClasses.firstButton}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  [`& .${toggleButtonGroupClasses.middleButton}`]: {
    borderRadius: 0,
  },
  [`& .${toggleButtonGroupClasses.lastButton}`]: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
}));

interface Props extends ToggleButtonGroupProps {
  children: ReactNode;
}

export default function CustomToggleButtonGroup({ onChange, exclusive, ...props }: Props) {
  const handleChange = useCallback(
    (event: MouseEvent<HTMLElement>, newValue: unknown) => {
      if (exclusive && newValue === null) {
        return;
      }
      onChange?.(event, newValue);
    },
    [onChange, exclusive],
  );

  return (
    <StyledToggleButtonGroup
      exclusive={exclusive}
      onChange={handleChange}
      {...props}
    />
  );
}
